import { render, staticRenderFns } from "./InitiateImpersonation.vue?vue&type=template&id=788a60f4&scoped=true"
import script from "./InitiateImpersonation.vue?vue&type=script&lang=ts"
export * from "./InitiateImpersonation.vue?vue&type=script&lang=ts"
import style0 from "./InitiateImpersonation.vue?vue&type=style&index=0&id=788a60f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788a60f4",
  null
  
)

export default component.exports